import { memo, useCallback } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'

import { ConfirmationDialog } from '@collaborate-health/uikit'
import { restoreFolder } from '@tabeeb/modules/sessionsPage/actions'

const RestoreFolderDialog = ({ open, folder, onClose }) => {
  const dispatch = useDispatch()

  const onSubmit = useCallback(() => {
    dispatch(restoreFolder.request(folder.Id))

    onClose()
  }, [dispatch, folder?.Id, onClose])

  return (
    <ConfirmationDialog
      isOpen={open}
      title='Restore folder'
      dialogMessage='Are you sure you want to restore this folder?'
      onCloseDialog={onClose}
      onSubmit={onSubmit}
      cancelButtonText='No'
      submitButtonText='Yes'
    />
  )
}

RestoreFolderDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  folder: PropTypes.shape({
    Id: PropTypes.number.isRequired,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
}

export default memo(RestoreFolderDialog)
